import { createApp } from "vue";
import {
  Quasar,
  Notify,
  ClosePopup,
  QBtn,
  QBtnGroup,
  QCard,
  QDialog,
  QForm,
  QIcon,
  QInput,
  QItem,
  QList,
  QMenu,
  QSeparator,
  QSpinnerDots,
  QVirtualScroll,
} from "quasar";
import quasarLang from "quasar/lang/pt-BR";

import { autoAnimatePlugin } from "./vendor/autoAnimateVuePlugin.js";
import { attachErrorHandler } from "@sentry/vue";

const page = async () => {
  const attr = document.body.getAttribute("js-page");

  const pages = {
    cadastro_fisico: () => import("./pages/cadastro_fisico.js"),
    minha_conta: () => import("./pages/minha_conta.js"),
    habilitar_se: () => import("./pages/minha_conta.js"),
    cadastro_juridico: () => import("./pages/cadastro_juridico.js"),
    lote: () => import("./pages/lote.js"),
    leilao: () => import("./pages/leilao.js"),
    compra_parcelada: () => import("./pages/compra_parcelada.js"),
  };

  return pages[attr] ? await pages[attr]() : null;
};

console.log(
  "App.js carregado - js-page:",
  document.body.getAttribute("js-page")
);

(async () => {
  const attr = document.body.getAttribute("js-page");
  if (!attr) return;

  const resolvedPage = await page();

  if (resolvedPage) {
    const app = createApp(resolvedPage.default);

    if (window.GLITCHTIP_CONFIG?.dsn && !app.__glitchTipVueAttached) {
      attachErrorHandler(app, { attachProps: false });
      app.__glitchTipVueAttached = true;
    }

    app.use(Quasar, {
      plugins: { Notify },
      lang: quasarLang,
      components: {
        QDialog,
        QCard,
        QBtn,
        QBtnGroup,
        QSpinnerDots,
        QForm,
        QInput,
        QMenu,
        QList,
        QItem,
        QVirtualScroll,
        QIcon,
        QSeparator,
      },
      directives: { ClosePopup },
      config: { notify: {} },
    });

    app.use(autoAnimatePlugin);
    app.mount("#app");

    Notify.registerType("alert", {
      progress: true,
      classes: "notify-alert",
      timeout: 3000,
      position: "top",
    });
  }
})();

export const NotifyAlert = (text, opts) => {
  Notify.create({ type: "alert", message: text, ...opts });
};
